import { createSlice } from "@reduxjs/toolkit";

// Create user-related slice for managing all state related to conversations, classes, filters, and profile
const userSlice = createSlice({
    name: "user",
    initialState: {
        recentLoading: false,
        fetchConversation: [],
        convoLoading: false,
        allConversationData: {},
        classDataLoading: false,
        allClassData: [],
        modalClassesLoading: false,
        conversationById: [],
        conversationLoading: false,
        modifyLoading: false,
        getChoices: [],
        getEstimateCost: [],
        getGenerateQueryMessage: [],
        formikValues: [],
        queryResponse: [],
        modifyClassData: [],
        optionsData: {},
        filterGrpData: [],
        groupLoading: false,
        filterUserData: [],
        userProfileData: {},
        clearFilter: false,
        searchValue: "",
        startDate: "",
        endDate: "",
        dateLabel: "",
        sessionReady: false,
    },

    reducers: {
        // Reducer to store recent conversations
        fetchAllData: (state, action) => {
            state.recentLoading = action.payload.recentLoading;
            state.fetchConversation = action.payload.fetchConversation;
        },

        // Reducer to manage all conversations list
        allConversationReduc: (state, action) => {
            state.convoLoading = action.payload.convoLoading;
            state.allConversationData = action.payload.data;
        },

        // Reducer to manage class/category data
        classDataReduc: (state, action) => {
            state.classDataLoading = action.payload.classDataLoading;
            state.allClassData = action.payload.data;
            state.modifyClassData = action.payload.modifyClassData;
        },

        // Reducers to manage class add/edit/delete modal loading state
        addClassesReduc: (state, action) => {
            state.modalClassesLoading = action.payload.modalClassesLoading;
        },
        editClassesReduc: (state, action) => {
            state.modalClassesLoading = action.payload.modalClassesLoading;
        },
        deleteClassesReduc: (state, action) => {
            state.modalClassesLoading = action.payload.modalClassesLoading;
        },

        // Reducer to store conversation detail by ID
        conversationByIdReduc: (state, action) => {
            state.optionsData = action.payload.optionsData;
            state.conversationById = action.payload.data;
            state.conversationLoading = action.payload.conversationLoading;
        },

        // Reducer to store modify response loading state
        modifyResponseReduc: (state, action) => {
            state.modifyLoading = action.payload.modifyLoading;
        },

        // Reducer to store available choices for dropdowns/selections
        getChoiceReduc: (state, action) => {
            state.getChoices = action.payload.getChoices;
        },

        // Reducer to store EstimateCost of the Query
        getEstimateCostReduc: (state, action) => {
            state.getEstimateCost = action.payload.getEstimateCost;
        },

        // Reducer to store generated query message and form values
        generateQueryReduc: (state, action) => {
            state.getGenerateQueryMessage = action.payload.getGenerateQueryMessage;
            state.formikValues = action.payload.formikValues;
        },

        // Reducer to store query API response
        queryResponseReduc: (state, action) => {
            state.queryResponse = action.payload.queryResponse;
        },

        // Reducer to store available group filters
        filterReduc: (state, action) => {
            state.filterGrpData = action.payload.data;
            state.groupLoading = action.payload.loading;
        },

        // Reducer to store users under selected group
        filterUserReduc: (state, action) => {
            state.filterUserData = action.payload.userdata;
        },

        // Reducer to store user profile data or only profile image update
        profileDataReduc: (state, action) => {
            if (typeof action.payload.userdata === "string") {
                state.userProfileData = {
                    ...state.userProfileData,
                    profile_pic: action.payload.userdata,
                };
            } else {
                state.userProfileData = action.payload.userdata;
            }
        },


        // Reducer to set filter reset flag
        resetFilterReduc: (state, action) => {
            state.clearFilter = action.payload.data;
        },

        // Reducer to store search text input value
        searchStringValueReduc: (state, action) => {
            state.searchValue = action.payload.data;
        },

        // Reducer to store selected date range for filtering
        setDateRange: (state, action) => {
            state.startDate = action.payload.startDate;
            state.endDate = action.payload.endDate;
        },

        // Reducer to store the label text for date filter (e.g., "Last 7 Days")
        dateLabelReduc: (state, action) => {
            state.dateLabel = action.payload.data;
        },
        setSessionReady: (state, action) => {
            state.sessionReady = action.payload;
        },
    },
});

// Export actions
export const {
    fetchAllData,
    allConversationReduc,
    classDataReduc,
    addClassesReduc,
    editClassesReduc,
    deleteClassesReduc,
    conversationByIdReduc,
    modifyResponseReduc,
    getChoiceReduc,
    getEstimateCostReduc,
    generateQueryReduc,
    filterReduc,
    filterUserReduc,
    queryResponseReduc,
    profileDataReduc,
    resetFilterReduc,
    searchStringValueReduc,
    setDateRange,
    dateLabelReduc,
    setSessionReady,
} = userSlice.actions;

// Selector to access user slice
export const userSelector = (state) => state.user;

// Export reducer
const userReducer = userSlice.reducer;
export default userReducer;
